import checkIgnore from "./check-ignore";
import ignoreList from "./ignore-list"

export default function buildRollbarConfig($config, nuxtApp) {
  return {
    enabled: $config.enableRollbar,
    accessToken: process.server ? $config.rollbarTokenServer : $config.rollbarTokenClient,
    captureUncaught: true,
    captureUnhandledRejections: true,
    reportLevel: $config.rollbarReportLevel,
    scrubFields: ['at', 'Authorization'],
    payload: {
      environment: $config.environment === 'LIVE' ? 'production' : $config.environment,
      client: {
        javascript: {
          source_map_enabled: true, // true by default
          code_version: $config.codeVersion,
          // ---------------------------------------
          // Optionally have Rollbar guess which frames the error was
          // thrown from when the browser does not provide line
          // and column numbers.
          guess_uncaught_frames: true
        }
      },
      custom: {
        tenant: $config.tenantName ? $config.tenantName : 'Lendio'
      }
    },
    onSendCallback: function (isUncaught, args, payload) {
      try {
        if (window?._fs_namespace) {
          // Include FullStory session URL in the payload if available
          payload.fullstorySessionUrl = window[_fs_namespace]?.getCurrentSessionURL(false) || null;
        }
      } catch (e) {
        return; // do nothing
      }
    },
    checkIgnore: checkIgnore(ignoreList, nuxtApp)
  }
}
